import { BaseTranslation } from 'src/i18n/i18n-types';

export const template: BaseTranslation = {
  createNew: 'New Concept',
  aiTemplate: 'AI Concept',
  generateConcept: 'Generate Concept',
  next: 'Next',
  back: 'Back',
  generate: 'Generate',
  brandName: 'Brand',
  productName: 'Product Name',
  productDescription: 'Product Description',
  brandProfileInput: 'Search or create brand',
  productProfileInput: 'Search or create product',
  createBrandProfile: 'Create new brand "{name}"',
  createProductProfile: 'Create new product "{name}"',
  magicInTheMaking: 'Magic in the making...',
};
